<template>
    <modal class="new-modal-default small-modal configure-qr-code-modal" transition="nice-modal-fade" :name="modal_name" :delay="100"
        :width="200" height="auto" :adaptive="true" :scrollable="true" :clickToClose="false">
        <div class="v-modal-content" style="background-color: #ffffff !important;">
            <div class="v-modal-header-new">
                <div></div>
                <div>
                    <span class="v-modal-dialog-title-new v-modal-title text-white fs-20">Configure New QR Code</span>
                </div>
                <!-- <div>
                    <span class="icon icon-close mr-2 text-white pointer close-left" @click="hideModal"></span>
                </div> -->
            </div>
            <div class="mb-3"> 
                    <div>
                        <span class="fs-12 text-secondary ml-5">Code Info</span>
                    </div>
                </div>
            <div class="v-modal-body">
                <div class="v-modal-layout px-4 pb-4" style="border: 0.5px solid #0d84f2; border-radius: 6px;">
                    <div  class="d-flex align-items-center py-2 mt-2">
                                <span class=" fw-600 fs-15 mr-2" style="width: max-content;min-width: max-content; color:#130e0e">QR Code Details</span>
                                <div class="inner-line-hr w-100"></div>
                            </div>
                    <div class="row">
                        <div class="col-lg-12 col-md-12 col-sm-12">
                            <div class="form-group contactGroup">
                                <span class="whiteSpace fs-14 fw-500 text-blackpx-2">Facility Name<span
                                        class="text-danger">*</span></span>
                                <div class="">
                                    <multiselect v-model="facility_name"
                                        class="diginew-multiselect down-arrow custom-cred-fs mt-3"
                                        :loading="facility_loading" :options="facility_name_options" :searchable="true"
                                        :close-on-select="true" name="facility_name" :show-labels="false"
                                        @search-change="searchFacility" @open="getFacility" @select="selectedFacility"
                                        :allow-empty="false" :multiple="false" :options-limit="3000" :max-height="200"
                                        v-validate="'required'"
                                        :clear-on-select="false" placeholder="Select Facility" :internal-search="true"
                                        :show-no-results="true" :hide-selected="false" label="facility_name">
                                        <template slot="afterList">
                                            <div v-observe-visibility="reachedEndOfFacilityNameList" />
                                        </template>
                                        <template slot="noResult">
                                            <div class="text-secondary text-center fw-600">No Results Found</div>
                                        </template>
                                    </multiselect>
                                </div>
                                <span class="invalid-feedback-form text-danger"
                                    v-show="errors.has('facility_name')">{{errors.first('facility_name')}}</span>
                            </div>
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12">
                            <div class="form-group contactGroup">
                                <div class="w-100" style="position: relative;">
                                    <label class="inputLabel fs-14 fw-500 text-black">Location</label>
                                    <input class="inputFieldNew inputFieldNew-padding" readonly style="padding-right: 60px !important;" name="location" v-model="location" type="text" autocomplete="off" placeholder="Autofilled" />
                                    <span class="inputBorder"></span>
                                    <i class="icon icon-map-marker color-blue"
                                                style="position: absolute;right: 35px;bottom: 9px;"></i>
                                    <i class="icon icon-check fs-24 text-success ml-2" style="position: absolute;right: 10px;top: 45px;"></i>
                                </div> 
                            </div>
                        </div>
                    </div>
                </div>

                <div class="v-modal-dialog-actions-new">
                    <div class="d-flex justify-content-center align-items-center mt-5">
                        <button class="btn btn-danger-new fw-500  mr-3" @click="hideModal">Cancel</button>
                        <button class="btn btn-green fw-500 ml-3" :disabled="is_api_calling" @click="saveCreateData" :class="{'text-align-left': is_api_calling}">
                            {{ is_api_calling ? 'Saving' : 'Save' }}
                            <half-circle-spinner v-if='is_api_calling' :animation-duration="1000" :size="20" color="#00448b" style="margin: 0 auto;top:-25px;left:30px" />
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
    </modal>
</template>

<script>
    import facility_mgmt from '../../mixins/facility_mgmt';
    import { SweetModal } from 'sweet-modal-vue';
    import { HalfCircleSpinner } from "epic-spinners";
    import { debounce } from 'lodash';
    export default {
        components: {
            SweetModal,
            HalfCircleSpinner
        },
        mixins: [facility_mgmt],
        props: ['modal_name'],
        data() {
            return {
                success_msg: '',
                warning_msg: '',
                facility_name: '',
                facility_name_options: [],
                location: "",
                facility_count: 0,
                facility_loading: false,
                isVisible: false,
                scrollable: false,
                is_api_calling: false
            }
        },
        methods: {
            hideModal() {
                this.$emit('hide-add-qrcode-modal')
            },
            async searchFacilityDebouncer(search_key) {
                this.facility_loading = true;
                this.search_key = search_key || '';
                try {
                    let params = {
                        skip: 0,
                        for_dropdown: true,
                        limit: 10,
                        search_key: this.search_key,
                        sort_key: "facility_name",
                        sort_value: 1
                    };
                    let response = await this.getFacilityLocationList(params);
                    this.facility_name_options = response.response.facility_list;
                    this.facility_count = response.response.facility_list.length;
                    this.facility_loading = false;
                } catch (error) {
                    // console.log(error);
                }
            },
            async getFacility() {
                this.facility_loading = true;
                try {
                    let params = {
                        skip: 0,
                        limit: 10,
                        search_key: '',
                        for_dropdown: true,
                        sort_key: "facility_name",
                        sort_value: 1
                    };
                    let response = await this.getFacilityLocationList(params);
                    this.facility_name_options = response.response.facility_list;
                    this.facility_count = response.response.facility_list.length;
                    this.facility_loading = false;
                } catch (error) {
                    // console.log(error);
                }
            },
            selectedFacility(data){
                this.location = data.location
            },
            async reachedEndOfFacilityNameList(reached) {
                this.isVisible = reached;
                if (reached) {
                    if (this.scrollable == false) {
                        this.facility_loading = true;
                        let params = {
                            limit: 10,
                            search_key: this.search_key,
                            skip: this.facility_count,
                            for_dropdown: true,
                            sort_key: "facility_name",
                            sort_value: 1
                        };
                        let response = await this.getFacilityLocationList(params);
                        let temp_facility_name_options = response.response.length;
                        if (response.skip == this.facility_count) {
                            if (temp_facility_name_options > 0) {
                                let tempFiles = response.response.facility_list;
                                tempFiles.forEach(el => {
                                    this.facility_name_options.push(el);
                                });
                                this.facility_count += response.response.length;
                                this.facility_loading = false
                            } else {
                                this.scrollable = true
                                this.facility_loading = false
                            }
                        }
                        this.facility_loading = false
                    }
                }
            },
            saveCreateData() {
                this.$validator.validateAll().then(async result => {
                    if (result) {
                        this.saveSuccess();
                    } else {
                        this.warning_msg = "Please fill all the required fields";
                        this.$refs.warning_modal.open();
                        setTimeout(() => {
                            this.$refs.warning_modal.close();
                        }, 3000);
                    }
                });
            },
            async saveSuccess() {
                this.is_api_calling = true;
                try {
                    let response = await this.createQrCode(this.create_data);
                    this.success_msg = response.response.success_message
                    this.$refs.success_modal.open();
                    setTimeout(() => {
                        this.$refs.success_modal.close();
                        this.hideModal();
                        this.$emit('saveSuccess')
                    }, 3000);
                }
                catch (error) {
                    this.is_api_calling = false;
                    this.warning_msg = error;
                    this.$refs.warning_modal.open();
                }
            }
        },
        computed: {
            loggedInUser() {
                return this.$store.getters.loggedInUser;
            },
            create_data() {
                return {
                    facility_id: this.facility_name._id,
                    location: this.location,
                };
            },
        },
        created() {
            this.searchFacility = debounce(this.searchFacilityDebouncer, 500)
            const dict = {
                custom: {
                    facility_name:{
                        required:() => "Facility Name is required"
                    },
                }
            }
            this.$validator.localize('en', dict)
        }
    }
</script>

<style scoped>
.inner-line-hr{
    border: 0;
    width: 100%;
    border-top: 2px solid #a5a5a5;
}
.border{
    border:0.5px solid #0d84f2 !important;
}
.v-modal-dialog-actions-new {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: flex-end;
    padding: 15px;
    border-top: 0px solid transparent;
}

.v-modal-header-new {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: start;
    -webkit-align-items: flex-start;
    -ms-flex-align: start;
    align-items: flex-start;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    -ms-flex-pack: justify;
    justify-content: flex-start;
    padding-left: 15px;
    padding-top: 15px;
    border-bottom: 0px solid #E9ECEF;
    -webkit-border-top-left-radius: 15px;
    border-top-left-radius: 15px;
    -webkit-border-top-right-radius: 15px;
    border-top-right-radius: 15px;
    background-color: white !important;
}
.v-modal-dialog-title-new{
    margin-bottom: 0px !important;
    font-size: 20px !important;
    font-weight: 600 !important;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    color: #00448b !important;
    padding: 4px !important;
}
    .color-blue {
        color: #005dae;
    }

    .bord-rad-18px {
        border-radius: 18px !important;
    }

    .form-group {
        margin-bottom: 0.2rem;
    }

    .form-group.formsearch .form-control {
        border-radius: 18px !important;
    }

    @media screen and (min-width: 1280px) {
        .form-group.formsearch {
            width: 225px;
        }
    }

    @media (max-width: 768px) {
        .form-group.formsearch {
            width: 180px;
        }
    }

    .form-group.select-label .form-control {
        width: 100% !important;
        max-width: 100%;
    }

    .form-group input[type="search"].form-control {
        height: 32px !important;
    }

    .form-group.formsearch input[type="text"].form-control::-webkit-input-placeholder {
        line-height: 1.42857143 !important;
        font-size: 14px;
        font-family: inherit;
        border-radius: 0px !important;
        box-shadow: none !important;
        overflow: visible;
        color: #4e5764 !important;
    }

    .form-group.formsearch input[type="text"].form-control::-moz-placeholder {
        line-height: 1.42857143 !important;
        font-size: 14px;
        font-family: inherit;
        border-radius: 0px !important;
        box-shadow: none !important;
        overflow: visible;
        color: #4e5764 !important;
    }

    .form-group.formsearch input[type="text"].form-control:-ms-input-placeholder {
        line-height: 1.42857143 !important;
        font-size: 14px;
        font-family: inherit;
        border-radius: 0px !important;
        box-shadow: none !important;
        overflow: visible;
        color: #4e5764 !important;
    }

    .form-group.formsearch input[type="text"].form-control:-moz-placeholder {
        line-height: 1.42857143 !important;
        font-size: 14px;
        font-family: inherit;
        border-radius: 0px !important;
        box-shadow: none !important;
        overflow: visible;
        color: #4e5764 !important;
    }

    .form-group .help-block {
        position: absolute;
        margin: .8rem 0 0;
        opacity: 0;
        filter: alpha(opacity=0);
        font-size: 12px;
        display: block;
        right: 0px;
    }

    .form-group .inputField:focus~span.help-block {
        color: #1a9347;
        opacity: 1;
        filter: alpha(opacity=100);
    }

    .form-group .inputFieldNew:focus~span.help-block {
        color: #1a9347;
        opacity: 1;
        filter: alpha(opacity=100);
    }

    .form-group input[type="text"].form-control::-webkit-input-placeholder,
    .form-group>.input-group input[type="text"].form-control::-webkit-input-placeholder,
    .form-group>.input-group>.form-control::-webkit-input-placeholder,
    .form-group input[type="email"].form-control::-webkit-input-placeholder,
    .form-group input[type="password"].form-control::-webkit-input-placeholder,
    textarea.form-control::-webkit-input-placeholder,
    .form-group input[type="text"].form-control.is-invalid::-webkit-input-placeholder,
    .vue-tel-input.tel-input-class .input-group input[type="text"].form-control.is-invalid::-webkit-input-placeholder,
    .form-control.is-invalid::-webkit-input-placeholder,
    select.form-control::-webkit-input-placeholder {
        color: #4e5764 !important;
        font-weight: normal !important;
    }

    .form-group,
    .form-check {
        will-change: unset !important;
    }
</style>